module.exports = "<div ncy-breadcrumb></div> <h1>{{ ::vm.discounttype.name }}</h1> <product-overview context=discounttype-overview on-filter-change=vm.onFilterChange() model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/discount/discounttype.html
// module id = 592
// module chunks = 0